<template>
  <app-header></app-header>
  <div class="application-height">
    <router-view />
  </div>
  <app-footer></app-footer>
</template>

<script setup>
import AppHeader from '@modules/app-header/index.vue'
import AppFooter from '@modules/app-footer/index.vue'
</script>

<style lang="scss">
@import '@/assets/theme/index.scss';
</style>
